import { KText } from '@/ui-library/components/text';
import { Flex, Icon } from '@chakra-ui/react';

export const SelectOptionWithIcon = (option) => {
  const { label, icon, showIcon = true, iconProps = {} } = option;

  return (
    <Flex gap="6px" alignItems="center">
      {showIcon && <Icon as={icon} width="20px" height="20px" {...iconProps} />}
      <KText>{label}</KText>
    </Flex>
  );
};
